import { render, staticRenderFns } from "./TraxUiAjaxStructWithActions.vue?vue&type=template&id=85e126d2"
import script from "./TraxUiAjaxStructWithActions.vue?vue&type=script&lang=js"
export * from "./TraxUiAjaxStructWithActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports